<div class="flex flex-wrap gap-2 px-4 pt-4">
  @for (button of buttons; track button; let i = $index) {
    <div
      class="relative flex-1"
      style="min-width: 45%"
      >
      @if (button.externalHref) {
        <!--
          a11y: accessible name comes from the visible <span> (button.label)
          plus a visually-hidden <span> with the "opens in a new tab" hint.
          We intentionally DO NOT set [aria-label] here — combining aria-label
          with the visible inner text caused VoiceOver/TalkBack to read the
          label twice and the role "link" twice (see audit screenshot:
          "...הרשמה לדיווחים, קישור, אתר חיצוני, נפתח בכרטיסיה חדש קישור").
          With a single visible name + sr-only hint, the screen reader now
          says "<label>, <hint>, link" once.
          The icon is purely decorative → aria-hidden.
        -->
        <a
          mat-button
          class="result-buttons !w-full !rounded-lg !border !border-solid !border-gray !normal-case !justify-center !min-h-[48px]"
          [href]="button.externalHref"
          target="_blank"
          rel="noopener noreferrer"
          [attr.cdkFocusInitial]="focusInitialOnFirst && i === 0 ? '' : null"
          >
          @if (button.icon) {
            <ng-icon class="!text-2xl" [name]="button.icon" aria-hidden="true"></ng-icon>
          }
          @if (button.label) {
            <span>{{ button.label }}</span>
          }
          @if (button.externalLinkHint) {
            <span class="sr-only">{{ button.externalLinkHint }}</span>
          }
        </a>
      }
      @if (!button.externalHref) {
        <mot-button
          [icon]="button.icon"
          [text]="button.label"
          [ariaLabel]="button.ariaLabel"
          class="!w-full"
          (onClick)="button.onClick && button.onClick()"
          class="flex-1"
          buttonClass="result-buttons !w-full !rounded-lg !border !border-solid !border-gray"
          iconClass="!text-2xl"
          [disabled]="button.disabled"
          [tooltip]="button.tooltip"
          [ariaHaspopup]="button.ariaHaspopup"
          [focusInitial]="focusInitialOnFirst && i === 0"
          >
        </mot-button>
      }
      @if (button.name === 'specialMessages' && button.counter > 0) {
        <app-special-messages-counter
          class="absolute top-[20%] left-[10%] cursor-pointer"
          [messagesCounter]="button.counter"
          (click)="button.onClick()"
          />
      }
    </div>
  }
</div>
